module.exports = __webpack_public_path__ + "static/media/237-netherlands.b1f1be5d.svg";